export default __webpack_public_path__ + "img/a904569214968a2c76e6b38bcfe792a4-UC-Santa-Barbara-Wordmark-White.svg";